import FamilyMemberTypeEnum from "../FamilymemberTypeEnum";

const employeesList = [
    

]

export default employeesList;